
<div class="control-group">
  <row>
    <column>
      <button
        class="toggle-group"
        :class="classes"
        type="button"
        data-toggle="collapse"
        :data-target="'#' + safeId"
        aria-expanded="false"
        :aria-controls="safeId"
      >

        <template v-if="index >= 0 && includeIndex">
          <pencil color="Orange">
            {{indexPrefix}}{{index}}.
          </pencil>
        </template>

        <template v-if="color && icon">
          <icon :glyph="icon"></icon>
        </template>

        <span class="control-group-name">
          {{ groupName }}
        </span>
        <slot name="suffix-text"></slot>
      </button>
    </column>
    <slot name="suffix"></slot>
  </row>

  <component
    :is="contentTag"
    :id="safeId"
    class="collapse"
    v-bind:class="{show: disabled ? '' : startExpanded}"
  >
    <slot></slot>
  </component>
</div>
